const CLASSES = [
  {
    name: 'Barbarian',
    hit_die: 12,
    imagePath: '/class/barbarian/barbarian_create.png',
    description:
      'A fierce warrior who channels primal rage into devastating combat power. Barbarians are relentless front-liners whose fury grants them supernatural strength and resistance to damage. Their unarmored toughness and reckless ferocity make them among the most durable fighters in any party.',
  },
  {
    name: 'Bard',
    hit_die: 8,
    imagePath: '/class/bard/bard_create.png',
    description:
      'An inspiring spellcaster who weaves magic through performance — song, poetry, and storytelling. Bards use their vast knowledge and quick wit to inspire allies, confound enemies, and cast spells from a broad repertoire. Their versatility makes them invaluable companions in and out of combat.',
  },
  {
    name: 'Cleric',
    hit_die: 8,
    imagePath: '/class/cleric/cleric_create.png',
    description:
      'A priestly champion who wields divine magic in service of a higher power. Clerics channel their deity\'s will to heal wounds, smite enemies, and turn the undead. The divine domain they follow shapes their abilities and defines the nature of their sacred calling.',
  },
  {
    name: 'Druid',
    hit_die: 8,
    imagePath: '/class/druid/druid_create.png',
    description:
      'A priest of the Old Faith who draws power from nature and can transform into wild beasts. Druids command elemental forces, commune with animals, and wield powerful nature magic that can reshape the battlefield. Their Wild Shape ability makes them uniquely adaptable to any situation.',
  },
  {
    name: 'Fighter',
    hit_die: 10,
    imagePath: '/class/fighter/fighter_create.png',
    description:
      'A master of martial combat, proficient with every weapon and suit of armor. Fighters are disciplined warriors who have refined their technique through relentless training, and their superior action economy lets them attack more often than any other class. Their martial archetype shapes them into specialists who excel at their chosen style of combat.',
  },
  {
    name: 'Monk',
    hit_die: 8,
    imagePath: '/class/monk/monk_create.png',
    description:
      'A martial artist who harnesses ki — the mystic energy of life itself — to power extraordinary abilities. Monks move with preternatural speed, strike with unarmed blows that hit harder than most weapons, and can deflect missiles or stun opponents with a single touch. Their path of discipline transforms the body into a living weapon.',
  },
  {
    name: 'Paladin',
    hit_die: 10,
    imagePath: '/class/paladin/paladin_create.jpg',
    description:
      'A holy warrior sworn to a sacred oath that grants divine magic and unbreakable conviction. Paladins combine martial prowess with spellcasting, smiting foes with divine power and bolstering allies with an aura of protection. Their oath defines both their code of conduct and the miraculous abilities they wield in its name.',
  },
  {
    name: 'Ranger',
    hit_die: 10,
    imagePath: '/class/ranger/ranger_create.png',
    description:
      'A hunter and tracker who has mastered survival in the wilderness and the art of fighting chosen quarry. Rangers blend martial skill with nature magic, excelling at ambushes, favored enemy hunts, and navigating terrain that would stop other adventurers cold. Their bond with the natural world makes them deadly guides and relentless pursuers.',
  },
  {
    name: 'Rogue',
    hit_die: 8,
    imagePath: '/class/rogue/rogue_create.png',
    description:
      'A cunning scoundrel who deals devastating Sneak Attacks and thrives on stealth, trickery, and exploiting openings. Rogues are masters of skills — picking locks, disarming traps, and moving unseen — and their Uncanny Dodge lets them shrug off blows that would fell a lesser adventurer. Adaptable and resourceful, they are at home in any urban or dungeon environment.',
  },
  {
    name: 'Sorcerer',
    hit_die: 6,
    imagePath: '/class/sorcerer/sorceror_create.png',
    description:
      'A spellcaster born with innate magical power coursing through their bloodline or touched by a wild surge of arcane energy. Sorcerers cast with raw instinct rather than study, and their Metamagic ability lets them bend the rules of spellcasting — twinning spells, extending ranges, or quickening cast times. Their power is limited in breadth but extraordinary in intensity.',
  },
  {
    name: 'Warlock',
    hit_die: 8,
    imagePath: '/class/warlock/warlock_create.png',
    description:
      'A spellcaster who has forged a pact with a powerful extraplanar patron — a fiend, an archfey, or an eldritch entity from beyond the stars. Warlocks recover their spell slots on a short rest and channel their patron\'s power through Eldritch Invocations that grant unique, often unsettling abilities. The bargain they have struck comes with power, but the nature of the debt is never entirely clear.',
  },
  {
    name: 'Wizard',
    hit_die: 6,
    imagePath: '/class/wizard/wizard_create.png',
    description:
      'A scholarly magic-user who learns spells through intensive study and records them in a spellbook. Wizards have access to the broadest spell list in the game, and their arcane tradition shapes them into specialists — from battle-hardened Evokers to elusive Illusionists. A lifetime of research makes them the most versatile and adaptable spellcasters in existence.',
  },
];

export default CLASSES;
